export default __webpack_public_path__ + "static/media/loading.c4bf17ea.gif";